export default {"src":"/_next/static/media/white_quick_view.a43f10a9.svg","height":19,"width":30,"blurWidth":0,"blurHeight":0};